import { computed, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
// import { pageAccessedByReload } from "@/services/pageService";
import { LOCATION_QUERY_PARAM, LOCATION_ID_QUERY_PARAM } from '@/constants';

export default function useMenuRedirect() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const getSelectedLocation = computed(() => store.getters.getSelectedLocation);
    const isLocationReady = computed(() => store.getters.isLocationReady);

    watch(
        () => isLocationReady.value,
        () => handleRedirect()
    );
    watch(
        () => route.path,
        () => handleRedirect()
    );
    onMounted(() => handleRedirect());

    const handleRedirect = (attempts = 0) => {
        const maxAttempts = 20;
        const isMenuPage = route.path?.includes('/menu');
        const directTo = isMenuPage ? `/location?redirect=${location.pathname}` : '/location';
        const locationIsInUrl = location.toString().includes(LOCATION_QUERY_PARAM) || location.toString().includes(LOCATION_ID_QUERY_PARAM) || route.query?.location;

        if (store.getters.isCrawler || locationIsInUrl) return;
        if (attempts > maxAttempts) return router.replace(directTo);
        if (!isLocationReady.value || !getSelectedLocation.value) return setTimeout(() => handleRedirect(attempts + 1), 100);
        return;
    };
    return { isLocationReady };
}
